import React, {useState} from "react";
import Mainheader from "../components/MainHeader/Mainheader";
import {Link, useLocation, useNavigate} from "react-router";
import Nopreview from "../assets/images/Nopreview.svg";
import ExclamationIcon from "../assets/images/exclamation.svg";
import Preview from "../assets/images/preview.svg";
import {helpCenterApi, loginApi} from "../services/apiService";
import {toast} from "react-toastify";
import {useUserContext} from "../context/UserContext";
import Cookies from "js-cookie";
import Afterloginheader from "../components/MainHeader/Afterloginheader";

const ContactUs = () => {
  const {userData} = useUserContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formDataContact, setFormDataContact] = useState({
    types: "",
    name: "",
    email: "",
    phno: "",
    subject: "",
  });

  const [formErrorsContact, setFormErrorsContact] = useState({
    types: "",
    name: "",
    email: "",
    phno: "",
    subject: "",
  });

  const handleChangeContactForm = e => {
    const {name, value} = e.target;
    setFormDataContact({...formDataContact, [name]: value});
    setFormErrorsContact({...formErrorsContact, [name]: ""});
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {
      types: "",
      name: "",
      email: "",
      phno: "",
      subject: "",
    };

    if (formDataContact.types === "") {
      errors.types = "Please select type.";
      isValid = false;
    }

    if (formDataContact.name === "") {
      errors.name = "Please enter name.";
      isValid = false;
    }

    if (formDataContact.phno === "") {
      errors.phno = "Please enter phone number.";
      isValid = false;
    } else if (formDataContact.phno && !/^\d{5,10}$/.test(formDataContact.phno)) {
      errors.phno = "Phone number is not valid.";
      isValid = false;
    }

    if (formDataContact.email && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(formDataContact.email)) {
      errors.email = "Email address is invalid.";
      isValid = false;
    }

    setFormErrorsContact(errors);
    return isValid;
  };

  const handleSubmitContact = async () => {
    if (validateForm()) {
      try {
        setIsSubmitting(true);
        let formData = new FormData();
        formData.append("types", formDataContact?.types || "");
        formData.append("name", formDataContact?.name || "");
        formData.append("phno", formDataContact?.phno || "");
        formData.append("email", formDataContact?.email || "");
        formData.append("subject", formDataContact?.subject || "");

        let response = await helpCenterApi(formData);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg || "Submitted successfully.", {autoClose: 1500});
            setFormDataContact({
              types: "",
              name: "",
              email: "",
              phno: "",
              subject: "",
            });
            setFormErrorsContact({
              types: "",
              name: "",
              email: "",
              phno: "",
              subject: "",
            });
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
        setIsSubmitting(false);
      } catch (error) {
        setIsSubmitting(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      }
    }
  };

  return (
    <div className="Main">
      {userData ? <Afterloginheader data-testid="after-login-header" /> : <Mainheader data-testid="header" />}
      <div className="Fullbody">
        <div className="LoginBox">
          <h4>Contact Us</h4>
          <div className="conatctFormTypeCont">
            <ul className="contactFormLiat">
              <li>
                <label
                  onClick={() => {
                    setFormDataContact({...formDataContact, types: "Doctor"});
                    setFormErrorsContact({...formErrorsContact, types: ""});
                  }}>
                  <input type="radio" id="Doctor" name="types" value="Doctor" checked={formDataContact.types === "Doctor"} />
                  <span className="LogininfoLft">
                    <span className="NameWrapper">Doctor</span>
                  </span>
                </label>
              </li>
              <li>
                <label
                  onClick={() => {
                    setFormDataContact({...formDataContact, types: "Patient"});
                    setFormErrorsContact({...formErrorsContact, types: ""});
                  }}>
                  <input type="radio" id="Patient" name="types" value="Patient" checked={formDataContact.types === "Patient"} />
                  <span className="LogininfoLft">
                    <span className="NameWrapper">Patient</span>
                  </span>
                </label>
              </li>
            </ul>
            {formErrorsContact.types && (
              <div>
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsContact.types}
                </span>
              </div>
            )}
          </div>
          <div className="input-group">
            <input
              type="text"
              placeholder="Name"
              className={`emailInput ${formErrorsContact.name ? "inputHaveError" : ""}`}
              name="name"
              value={formDataContact.name}
              onChange={handleChangeContactForm}
            />
            {formErrorsContact.name && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsContact.name}
              </span>
            )}
          </div>
          <div className="input-group">
            <input
              type="text"
              placeholder="Your Phone"
              className={`emailInput ${formErrorsContact.phno ? "inputHaveError" : ""}`}
              name="phno"
              value={formDataContact.phno}
              onChange={handleChangeContactForm}
            />
            {formErrorsContact.phno && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsContact.phno}
              </span>
            )}
          </div>
          <div className="input-group">
            <input type="text" placeholder="Your Email" className="emailInput" name="email" value={formDataContact.email} onChange={handleChangeContactForm} />
          </div>
          <div className="input-group text-area-group">
            <textarea placeholder="Enter subject" className="emailInput" name="subject" value={formDataContact.subject} onChange={handleChangeContactForm} />
          </div>
          <button type="submit" className="login-button" name="Submit" onClick={() => handleSubmitContact()} disabled={isSubmitting}>
            {isSubmitting ? "Please wait..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
